import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import PhotoUpload from '@/views/PhotoUpload.vue';
import Gallery from '@/views/Gallery.vue';
import Questions from '@/views/Questions.vue';
import Corona from '@/views/Corona.vue';
import Impressum from '@/views/Impressum.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      hero: true,
    },
  },
  {
    path: '/home',
    redirect: '/',
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      hero: false,
    },
  },
  {
    path: '/galerie',
    name: 'gallery',
    component: Gallery,
    meta: {
      hero: false,
    },
  },

  {
    path: '/upload',
    name: 'upload',
    component: PhotoUpload,
    meta: {
      hero: false,
    },
  },
  {
    path: '/fragen',
    name: 'questions',
    alias: '/questions',
    component: Questions,
    meta: {
      hero: false,
    },
  },
  {
    path: '/corona',
    name: 'corona',
    component: Corona,
    meta: {
      hero: false,
    },
  },
  {
    path: '/impressum',
    name: 'impressum',
    alias: '/about',
    component: Impressum,
    meta: {
      hero: false,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  next();
});

export default router;
